import Vue from 'vue';

export const imgToBase64 = (img: File) =>
    new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader);
        fileReader.onerror = reject;
        fileReader.readAsDataURL(img);
    });

export const loadImage = (url: string) =>
    new Promise((resolve, reject) => {
        const image = new Image();
        image.src = url;
        image.onload = () => resolve(image);
        image.onerror = reject;
    });
export function strlen(str: string) {
    let len = 0;
    for (let i = 0; i < str.length; i++) {
        const c = str.charCodeAt(i);
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
            len++;
        } else {
            len += 2;
        }
    }
    return len;
}

export function isVersionAvailable(curVerion: string, neededVersion: string) {
    if (!curVerion || !neededVersion) {
        return false;
    }
    const curVerionStrs = curVerion.split('.');
    const neededVersionStrs = neededVersion.split('.');
    for (let i = 0; i < neededVersion.length; i++) {
        const cur = isNaN(+curVerionStrs[i]) ? 0 : +curVerionStrs[i];
        const needed = isNaN(+neededVersionStrs[i]) ? 0 : +neededVersionStrs[i];
        if (cur > needed) {
            return true;
        }
        if (cur < needed) {
            return false;
        }
    }
    return true;
}

export function resWrapper(originalMethod: Function) {
    return async function () {
        try {
            await originalMethod();
        } catch (err) {
            Vue.prototype.$message({
                showClose: false,
                message: err,
                type: 'error',
            });
        }
    };
}

export function skipLoadingWrapper(originalMethod: Function) {
    let isInterfaceLoading = false;
    return async function (...args: any) {
        if (isInterfaceLoading) {
            return;
        }
        isInterfaceLoading = true;
        try {
            await originalMethod(...args);
        } catch (err) {
            Vue.prototype.$message({
                showClose: false,
                message: err,
                type: 'error',
            });
        } finally {
            isInterfaceLoading = false;
        }
    };
}



/* eslint-disable no-empty */
/*
 * @Author: wangyufei05@kuaishou.com
 * @Date: 2021-09-24 19:52:22
 * @Description: 加减乘除
 */

const getReviseVar = (nums: number[]) => {
    const maxDecLength = Math.max.apply(
        null,
        nums.map(item => {
            const str = String(item).split('.')[1];
            return str ? str.length : 0;
        })
    );

    const decLengthSum = nums.reduce((sum, cur) => {
        const str = String(cur).split('.')[1];
        return str ? (str.length + sum) : sum;
    }, 0);

    return {
        maxDecLength,
        decLengthSum
    };
};

export function add(...nums: number[]) {
    const { maxDecLength } = getReviseVar(nums);
    const revisePow = Math.pow(10, maxDecLength);
    return nums.reduce((sum, cur) => sum + cur * revisePow, 0) / revisePow;
}

export function minus(num1: number, num2: number) {
    const { maxDecLength } = getReviseVar([num1, num2]);
    const revisePow = Math.pow(10, maxDecLength);
    return ((num1 * revisePow - num2 * revisePow) / revisePow).toFixed(maxDecLength);
}

export function mul(...nums: number[]) {
    const { decLengthSum } = getReviseVar(nums);
    const revisePow = Math.pow(10, decLengthSum);
    return nums.reduce((mulRes, cur, curInd) => {
        const m1 = mulRes.toString();
        const m2 = cur.toString();
        if(curInd === nums.length - 1) return (Number(m1.replace(".", "")) * Number(m2.replace(".", ""))) / revisePow;
        return (Number(m1.replace(".", "")) * Number(m2.replace(".", "")));
    }, 1);
}
export function divider(num1: number, num2: number, fixed?: number) {
    const d1 = num1.toString();
    const d2 = num2.toString();
    let t1 = 0;
    let t2 = 0;
    try {
        t1 = d1.toString().split(".")[1].length;
    } catch(e) { }
    try {
        t2 = d2.toString().split(".")[1].length;
    } catch(e) { }

    const res = (Number(d1.replace(".", "")) / Number(d2.replace(".", ""))) * Math.pow(10, t2 - t1);
    if(fixed) return res.toFixed(fixed);  // Number(res.toFixed(fixed)) 1.00 这种情况无法保留两位小数 但是返回的会是string；
    return res;
}
